import { Page, PaginationParams } from '@/shared/api/pagination';
import type { HIType } from '@/entities/monitoring/hi/@x/access-rule';
import type { AccessRuleBriefDashboardDTOResponse } from '@/entities/user/access-rule';
import type {
  AccessRuleHICreateRequest,
  AccessRuleHIResponse,
  AccessRuleHIUpdateRequest,
} from '@/entities/user/access-rule';
import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';

const baseURLOverride = {
  baseURL: '/api/monitoring/v4',
};
export class AccessRulesHiApi {
  static getRules(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get(`his/rules`, {
      ...options,
      params,
    });
  }
  static getRulesBrief(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<AccessRuleBriefDashboardDTOResponse>>(
      `/his/rules_brief`,
      {
        ...options,
        params,
        ...baseURLOverride,
      },
    );
  }

  static getRuleById(id: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get(`his/rule/${id}`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static updateRule(
    rule_id: string,
    payload: AccessRuleHIUpdateRequest,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.put<AccessRuleHIResponse>(
      `/his/rule/${rule_id}`,
      payload,
      {
        ...options,
        ...baseURLOverride,
      },
    );
  }

  static createRule(
    payload: AccessRuleHICreateRequest,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post<AccessRuleHIResponse>(`/his/rule`, payload, {
      ...options,
      ...baseURLOverride,
    });
  }

  static deleteRule(rule_id: string, options?: AxiosRequestConfig) {
    return monitoringInstance.delete(`/his/rule/${rule_id}`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getActions(options?: AxiosRequestConfig) {
    return monitoringInstance.get(`/his/rules/actions`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getAccesses(options: AxiosRequestConfig = {}) {
    return monitoringInstance.get(`/his/rules/accesses`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getTypesById(
    rule_id: string,
    params: PaginationParams,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.get<Page<HIType>>(`/his/rule/${rule_id}/types`, {
      ...options,
      ...baseURLOverride,
      params: params,
    });
  }
}